import React from 'react';
import { useFeatureFlag } from '@americanexpress/one-experiments';
import { locales } from '@americanexpress/conditional-features';
import { getActiveLocaleSelector, getTenancySelector } from '@americanexpress/travel-selectors';
import { useRouterPathname } from '@americanexpress/one-app-router';
import { useSelector } from 'react-redux';
import { getCookies } from '@americanexpress/one-app-ducks';
import TulipsSmartFill from './TulipsSmartFill';
import LxpSmartFill from './LxpSmartFill';
import LocationsSmartFill from './LocationsSmartFill';
import { FHR_KEY, THC_KEY, GUESTBOOK_KEY } from '../../constants/categoryConstants';
import locationContext from '../../context/locationsContext';
import GuestbookSmartFill from './GuestbookSmartfill';

const SmartFillVersion = () => {
  const locale = useSelector(getActiveLocaleSelector);
  const {
    config: {
      lineOfBusiness,
      isLxpSearch,
    },
  } = React.useContext(locationContext);
  const tenancy = useSelector(getTenancySelector);
  const { properties } = useFeatureFlag({ featureFlagName: `prebooking_LXP_smartfill-${lineOfBusiness}` });
  // todo replace with real FF when available
  const isGuestbook = useSelector(getCookies)?.tlsguestbook === 'true' && lineOfBusiness === GUESTBOOK_KEY;

  const isFhrThc = lineOfBusiness === FHR_KEY || lineOfBusiness === THC_KEY;

  const pathname = useRouterPathname();
  const isMobilePath = pathname.includes('mobile-app-search-flights');

  const shouldDisplayLxpSmartFill = isLxpSearch || (properties?.[tenancy]?.includes(locale)
  && !isGuestbook && !isMobilePath);

  const shouldDisplayLocationsSmartFill = (locale !== locales.EN_US)
    && isFhrThc;

  if (isGuestbook) {
    return <GuestbookSmartFill />;
  }
  if (shouldDisplayLxpSmartFill) {
    return <LxpSmartFill />;
  }
  if (shouldDisplayLocationsSmartFill) {
    return <LocationsSmartFill />;
  }
  return <TulipsSmartFill />;
};

export default SmartFillVersion;
